import { render, staticRenderFns } from "./KPanelHeader.vue?vue&type=template&id=68f0ffdf&"
import script from "./KPanelHeader.vue?vue&type=script&lang=js&"
export * from "./KPanelHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports